import { App } from "vue";
import WrapContainer from './src/index.vue'
export default {
    install(app:App){
        app.component('WrapContainer',WrapContainer)
    }
}